<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">资源管理</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="名称" prop="resourceName">
            <el-input v-model="queryParams.resourceName" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="resourceType">
            <el-select v-model="queryParams.resourceType" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in dict.type.integrate_resource_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="编号" prop="resourceNo">
            <el-input v-model="queryParams.resourceNo" placeholder="请输入编号"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="onAdd">新 增</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="resourceList" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="resourceName" label="名称"></el-table-column>
              <el-table-column prop="resourceNo" label="编号"></el-table-column>
              <el-table-column prop="areaCodeTranslated" label="区域"></el-table-column>
              <el-table-column prop="resourceTypeTranslated" label="类型"></el-table-column>
              <el-table-column prop="contactPerson" label="姓名"></el-table-column>
              <el-table-column prop="contactMobile" label="电话"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { listResourcePoi, delResourcePoi } from "@/api/src/poisource";
export default {
  name: "POIManagerView",
  controller: "UI",
  action: "POIManagerView",
  dicts: ['integrate_resource_type'],
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
          resourceName: '',
          resourceType: '',
          resourceNo: '',
          pageNum: 1,
          pageSize: 10
      },
      // 表格数据
      resourceList: [],
    };
  },
  created: function() {
    this.getList();
  },
  methods: {
    // 查询
    getList() {
      this.loading = true;
      listResourcePoi(this.queryParams).then(response =>{
        this.resourceList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.onSearch();
    },
    // 点击新增按钮
    onAdd() {
      this.$router.push({
        path: "/plugin/poi/ui/POIManagerEdit",
        query: { type: "add" },
      });
    },
    // 行查看
    queryDetail(row) {
      this.$router.push({
        path: "/plugin/poi/ui/POIManagerEdit",
        query: { id: row.id, type: "query" },
      });
    },
    // 行编辑
    editDetail(row) {
      this.$router.push({
        path: "/plugin/poi/ui/POIManagerEdit",
        query: { id: row.id, type: "edit" },
      });
    },
    // 行删除
    deleteClick(row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        return delResourcePoi(row.id);
      }).then(() => {
        this.$message({type: "success", message: "删除成功!"});
        this.getList();
      }).catch(() => {});
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    }
  },
};
</script>
